export default "__VITE_ASSET__DrZ_hDbk__"